import { render, staticRenderFns } from "./ReferralPopupDialogue.vue?vue&type=template&id=3bd2ce70&scoped=true"
import script from "./ReferralPopupDialogue.vue?vue&type=script&lang=js"
export * from "./ReferralPopupDialogue.vue?vue&type=script&lang=js"
import style0 from "./ReferralPopupDialogue.vue?vue&type=style&index=0&id=3bd2ce70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd2ce70",
  null
  
)

export default component.exports